import React, { FunctionComponent } from "react";

import { TAB_INDEX_FOCUSABLE_ONLY } from "@multiweb/reactUtils";
import { IconCode } from "@multiweb/types/contracts";
import { Role } from "@multiweb/uiShared/Role";
import { Icon, IconColor } from "../Icon";

export type CheckBoxIconProps = {
    /** Příznak, zda má být zobrazena zaškrtnutá ikona */
    checked: boolean;
    /** Příznak, zda je checkbox vizuálně neaktivní - výchozí hodnota je false */
    disabled?: boolean;
    /** Popisek */
    title?: string;
};

export const CheckBoxIcon: FunctionComponent<CheckBoxIconProps> = ({
    checked,
    disabled = false,
    title,
}) => (
    <Icon
        color={checked ? IconColor.green : IconColor.red}
        iconCode={checked ? IconCode.uiCheckSmall : IconCode.uiCrossSmall}
        role={Role.checkBox}
        tabIndex={TAB_INDEX_FOCUSABLE_ONLY}
        hideOutlineOnFocus={true}
        ariaChecked={checked}
        ariaDisabled={true}
        {...{ disabled, title }}
    />
);
